import { observer } from "mobx-react";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ShellPages } from "../../../../apps/_shell/routes/shellPages";
import { IF } from "../../../../components/hoc/If";
import { ButtonTypes, LinkButton } from "../../../../components/ui/Button";
import { Panel } from "../../../../components/ui/Panel";
import { PositionedSpinner } from "../../../../components/ui/PositionedSpinner";
import { useUserId } from "../../../../core/auth/authorise";
import { useFlightPathUser } from "../../../../core/auth_insight";
import I18n from "../../../../core/localization/I18n";
import { GridTypes } from "../../../../enums";
import { useCurrentOrganisationId } from "../../../../services/local/organisationContext/OrganisationContextModel";
import { ActionPies } from "./ActionPies";
import { ActionsModel } from "./Actions_model";
import { AppGrid } from "../../../../apps/grids/builder/directorBuilder/grids/base/AppGrid_view";

export const Actions: React.FC<{ shouldShowSeeAllButton?: boolean }> = observer(({ shouldShowSeeAllButton }) => {
  const organisationId = useCurrentOrganisationId();
  const { projectId } = useParams();
  const authUser = useFlightPathUser();
  const userId = useUserId();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const gridRef = useRef<AppGrid>();

  const [model] = useState(() => {
    const actionsModel = new ActionsModel(
      organisationId,
      +projectId,
      authUser,
      [],
      searchParams,
      [],
      GridTypes.ACTIONS_GRID,
      navigate,
      async () => {}
    );

    const onFieldUpdate = async () => {
      await actionsModel.loadActions();
    };

    actionsModel.gridModel.onFieldUpdate = onFieldUpdate;

    return actionsModel;
  });

  useEffect(() => {
    model.onMount();
    return model.onUnmount;
  }, [model]);

  return (
    <div className="col-6 mb-4">
      <ActionPies
        isLoading={model.isLoading}
        pieData={model.pieData}
        progressData={model.progressData}
        count={model.gridActions.length}
        authUser={{ ...authUser, id: +userId }}
      />
      <Panel.Panel
        className={`p-4 `}
        hasBorder={true}
        background={Panel.PanelBackgrounds.BG_LIGHT}
        hasBorderRadius={true}
      >
        <div className={`report-card report-card--md ${!shouldShowSeeAllButton ? "container-fluid mt-5" : ""}`}>
          <div className="row">
            <div className="col">
              <h2>{I18n.t("phrases.myActions")}</h2>
            </div>
          </div>
          <IF condition={model.isLoading}>
            <PositionedSpinner />
          </IF>
          <IF condition={!model.isLoading}>
            <AppGrid
              ref={gridRef}
              gridOptions={{ context: {} }}
              columnStateAddon={model.gridModel.columnStateAddon}
              filterStoreAddon={model.gridModel.filterStoreAddon}
              textWrapperAddon={model.gridModel.textWrapAddon}
              rowData={model.gridActions}
              columnDefs={model.gridModel.gridColumns}
              onCellClicked={() => {}}
              onCellEditModeChange={() => {}}
              onGridReady={model.onGridReady}
              onFirstData={() => {}}
              rowSelection="multiple"
              shouldTrackSelectedCell={true}
            />
            <IF condition={shouldShowSeeAllButton}>
              <div className="row">
                <div className="col mt-2">
                  <LinkButton
                    type={ButtonTypes.OUTLINE_PRIMARY}
                    href={ShellPages.dashboards.actions.generateLink(organisationId)}
                    className="float-right"
                  >
                    {I18n.t("phrases.seeAll")}
                  </LinkButton>
                </div>
              </div>
            </IF>
          </IF>
        </div>
      </Panel.Panel>
    </div>
  );
});
